import { hexToRGB } from '../../../../../../../lib/colourUtilities';
import theme from '../../../../../../../lib/theme';

const {
  corners,
  scale,
  shadows,
  colors,
  font: {
    families,
    heights,

    ...font
  },
  layouts,
} = theme;

export default () => ({
  link: {
    textDecoration: 'none !important',
    cursor: 'pointer',

    '&:hover .ArticleCard__title': {
      textDecoration: 'underline !important',
      color: colors.sas.primary,
    },

    '&:hover .ArticleCard__image': {
      boxShadow: shadows.lowest,
    },
  },

  title: {
    color: colors.black,
    fontFamily: families.primary,
    fontSize: font.xl,
    fontWeight: font.bold,
    lineHeight: heights.xl,
    marginBottom: 0,
    transition: 'all 150ms linear',
  },

  category: {
    color: colors.sas.primary,
    fontFamily: families.primary,
    fontSize: font.l,
    fontWeight: font.bold,
    lineHeight: heights.l,
    textDecoration: 'none !important',
    cursor: 'pointer',

    '&:hover': {
      textDecoration: 'underline !important',
    },
  },

  image: {
    width: '100%',
    borderRadius: corners.m,
    display: 'block',
  },
  
  subtitle: {
    fontFamily: families.primary,
    fontSize: font.m,
    lineHeight: heights.m,
    color: colors.black,
  },

  imageBackground: {
    display: 'flex',
    flex: 1,
    height: '100%',
    top: 0,
    left: 0,
    position: 'absolute',
    width: '100%',

    '& > button': {
      border: `2px solid ${colors.white}`,
      backgroundColor: hexToRGB(colors.white, '0.8'),
      color: colors.tas.primary,
      fontFamily: families.primary,
      fontSize: font.m,
      fontWeight: font.normal,
      lineHeight: heights.xxl,
      display: 'inline-block',
      position: 'absolute',
      left: 'calc(50% - 85px)',
      width: '170px',
      top: 'calc(50% - 22.5px)',
      height: '45px',
      borderRadius: '28.5px',
      cursor: 'pointer',
    },
  },
  featureImageContainer: {
    marginBottom: '0 !important',
    position: 'relative',
    width: '100%',
    borderRadius: corners.m,
    border: `1px solid ${colors.grey}`,
  },
});
